import React from 'react';
import { useAtomValue } from 'jotai';
import { useFetchUsageMetricTable } from '@components/usage-dashboard/hooks/dataFetcherhooks';
import { generateTableDataColumn } from '@components/usage-dashboard/utils';
import {
  apiAccountsDetailsAtom,
  appAccountsDetailsAtom,
  videoAccountsDetailsAtom,
} from '@components/usage-dashboard/atoms';
import { EMPTY_LENGTH } from '@components/usage-dashboard/constant';
import { UsageBaseTable } from '@components/usage-dashboard/MetricsTable/UsageBaseTable';
import { useExportMetricData } from '@components/usage-dashboard/hooks/useExportMetric';

export const UsageTable = ({ product }) => {
  const videoAccountsDetails = useAtomValue(videoAccountsDetailsAtom);
  const appAccountsDetails = useAtomValue(appAccountsDetailsAtom);
  const apiAccountsDetails = useAtomValue(apiAccountsDetailsAtom);

  useExportMetricData(product);

  const accountDetails = {
    EI: videoAccountsDetails,
    APP: appAccountsDetails,
    API: apiAccountsDetails,
  }[product];

  const accountType = {
    EI: 'Video',
    APP: 'App',
    API: 'API',
  }[product];

  const hasApiAccount = accountDetails.length > EMPTY_LENGTH;

  const { data: tableData, isFetching } = useFetchUsageMetricTable({
    enabled: hasApiAccount,
    product: product,
  });

  const { dataSource, columns } = generateTableDataColumn(tableData, accountDetails);

  if (!hasApiAccount) {
    return null;
  }

  return (
    <div style={{ padding: '0 12px' }}>
      <UsageBaseTable
        accountType={accountType}
        loading={isFetching}
        data={dataSource}
        columns={columns}
      />
    </div>
  );
};
